import React from 'react';

const TicketStatusBadge = ({ status = 'Abierto' }) => {
  let bgColor = '';
  let textColor = '';

  switch (status) {
    case 'Abierto':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-800';
      break;
    case 'En Progreso':
      bgColor = 'bg-yellow-100';
      textColor = 'text-yellow-800';
      break;
    case 'Cerrado':
      bgColor = 'bg-green-100';
      textColor = 'text-green-800';
      break;
    case 'Pendiente':
      bgColor = 'bg-orange-100';
      textColor = 'text-orange-800';
      break;
    default:
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
  }

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
      {status}
    </span>
  );
};

export default TicketStatusBadge;